import validate from "/tmp/tmpkxhg0ioy/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/tmp/tmpkxhg0ioy/middleware/redirect.global.ts";
import manifest_45route_45rule from "/tmp/tmpkxhg0ioy/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}